define('views/components/transaction/transaction_list',['require','views/base/list_view','views/components/transaction/transaction','text!templates/components/transaction/transaction_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/transaction/transaction');

    var temp = require("text!templates/components/transaction/transaction_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

